import React from 'react'; 
import { Card, CardContent, Typography, Grid } from '@mui/material';

interface FormCardProps {
  form: any;
  index: number;
  cardColors: string[];
  
  handleView: (formId: number) => void;
  handlestart: (formId: number) => void;
  formatDate: (dateString: string) => string;
}

const FormCard: React.FC<FormCardProps> = ({ form, index, cardColors, handleView, handlestart, formatDate }) => {
  const showScore = form.latest_form_submisson?.score != null && 
                    Number(form.latest_form_submisson.score) > 0 && 
                    form.id !== 27 && 
                    form.id !== 28;

  return (
    <Grid item xs={12} sm={6} md={4} >
      <Card
        sx={{
          backgroundColor: cardColors[index % cardColors.length],
          position: 'relative',
          height: '200px',
          transition: 'all 0.3s',
          boxShadow: '0 0 10px 2px #F0FFFF', // Blue shadow border effect
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          borderTop: `4px solid #0870b4`, // Top border color
        }}
      >
        <CardContent className="flex flex-col justify-between h-full">
          <Typography component="div" className="text-black text-start">
            <span className='text-lg font-jost '>{form.name}</span>
          </Typography>

          <Typography className="flex flex-col justify-center items-center text-black py-2" >
            {showScore ? (
              <span
                key={form.latest_form_submisson.id}
                className="bg-gray-400 text-md font-jost font-bold mb-2 py-1 px-4 rounded-lg shadow-md text-center"
                style={{ color: cardColors[index % cardColors.length] }}
              >
                Score: {form.latest_form_submisson.score} <br />
                Taken As: {formatDate(form.latest_form_submisson.created_at)}
              </span>
            ) : (
              <span className="text-gray-400 text-sm mb-6">
                No Data Here!
              </span>
            )}
          </Typography>
        </CardContent>

        <div className="flex justify-between gap-2">
          {form.id === 27 || form.id === 28 ? (
            <button
              onClick={() => handleView(form.id)}
              className={`w-full border-transparent py-2 bg-primary text-white transition-colors duration-300 ease-in-out rounded-lg${cardColors[index % cardColors.length]} cursor-pointer hover:shadow-lg transform hover:scale-105 flex justify-center`}
            >
              View
            </button>
          ) : (
            <>
              {form.latest_form_submisson && (
                <button
                  onClick={() => handleView(form.id)}
                  className={`w-full py-2 rounded-l-lg text-white bg-primary transition-colors duration-300 ease-in-out rounded-lg cursor-pointer hover:text-white hover:bg-${cardColors[index % cardColors.length]} hover:shadow-lg transform hover:scale-105 flex justify-center`}
                >
                  View
                </button>
              )}
              
            </>
          )}
        </div>
      </Card>
    </Grid>
  );
};

export default FormCard;
